import React from 'react';
import '../styles/ProfileSection.css';

const ProfileSection = () => (
  <div className="profile-section">
    <p>Architecture leader bridging IT and OT to deliver secure, scalable, observable systems across warehouse automation, manufacturing, and insurance. Drives modernization roadmaps; defines and publishes standards, reference architectures, and repeatable patterns; and improves end-to-end design documentation and handoffs. Partners with Platform, Integration, Infrastructure, Security, and Network teams to achieve interoperable, multi-vendor solutions with predictive monitoring/observability for resilience. Open to Head/Director of Architecture roles.
</p>
  </div>
);
export default ProfileSection;